// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'esca... Remove this comment to see the full error message
import escapeStringRegexp from 'escape-string-regexp';

/**
 * Generate a RegEx that matches any of the strings in the argument array.
 * @param  {String[]} stringList strings to match
 * @return {RegExp}
 */
export default function matchStrings(stringList: string[]): string {
  return stringList.map((x) => escapeStringRegexp(x)).join('|');
}
